import './Policy.css';
function Privacy() {
    return (
        <>   
           <section class="policy-wrap">
        <div class="container">
            <h4 class="policy-page-title">Privacy Policy</h4>
            <h4 class="policy-subtitle"><b>Effective Date:</b>01/07/2024</h4>
            <p>At SecureForMe, we are committed to protecting the privacy and security of your personal data. This Privacy Policy outlines how we collect, use, share, and protect the information we gather through our website and the products we offer, including Effortly for Endpoints, Effortly for Mobile, EmailDefence, and DLP Defence.</p>
            <h5 class="policy-title">1. Information We Collect</h5>
            <p>We collect different types of information based on the specific products and services you use. This information may include:</p>
            <h6 class="policy-subtitle">1.1 Effortly for Endpoints</h6>
            <ul class="policy-list">
                <li class="policy-list-item">
                    <b>Application and Website Usage Data:</b>
                    We monitor employees' use of applications and websites on their devices based on configured rules to assess productivity.
                </li>
                <li class="policy-list-item">
                    <b>Screenshots & Screen Recording:</b>
                    We capture and store screenshots and video recordings of employees' computer screens for a specified duration.
                </li>
                <li class="policy-list-item">
                    <b>Attendance Information:</b>
                    We track login and logout times to determine employee attendance.
                </li>
                <li class="policy-list-item">
                    <b>AIP-based Location Data:</b>
                    We collect IP addresses to identify and display employee locations on a map.
                </li>
                <li class="policy-list-item">
                    <b>Employee Personal Data:</b>
                    We store personal details such as name, contact information, and work-related data in an employee database.
                </li>
            </ul>
            <h6 class="policy-subtitle">1.2 Effortly for Mobile</h6>
            <ul class="policy-list">
                <li class="policy-list-item">
                    <b>GPS Location Data:</b>
                    We access and track employees' real-time location using GPS to monitor routes and distances travelled.
                </li>
                <li class="policy-list-item">
                    <b>Navigation Tracking:</b>
                    We monitor employees' navigation routes and calculate travel distances.
                </li>
                <li class="policy-list-item">
                    <b>Camera Access:</b>
                    We access the camera app on employees' mobile devices to capture facial images for attendance validation during check-in and check-out.
                </li>
                <li class="policy-list-item">
                    <b>Employee Personal Data:</b>
                    Personal details are stored in an employee database, similar to the Effortly for Endpoints product.
                </li>
            </ul>
            <h6 class="policy-subtitle">1.3 EmailDefence</h6>
            <ul class="policy-list">
                <li class="policy-list-item">
                    <b>Email Threat Monitoring:</b>
                    We monitor emails to prevent phishing, spam, viruses, and sensitive data loss.
                </li>
                <li class="policy-list-item">
                    <b>Encryption:</b>
                    We provide end-to-end encryption for emails to secure communication.
                </li>
                <li class="policy-list-item">
                    <b>Training Data:</b>
                    We collect information on employee participation in email threat training and simulation exercises.
                </li>
            </ul>
            <h6 class="policy-subtitle">1.4 DLPDefence</h6>
            <ul class="policy-list">
                <li class="policy-list-item">
                    <b>Device Activity Data:</b>
                    We monitor upload and download activities on employees' devices to restrict unauthorized data transfers.
                </li>
                <li class="policy-list-item">
                    <b>Disk Encryption Data:</b>
                    We manage and secure full disk encryption to prevent data loss.
                </li>
            </ul>
            <h5 class="policy-title">2. How We Use the Information</h5>
            <p>We use the information we collect to:</p>
            <ul class="policy-list">            
                <li>Enhance employee productivity and compliance.</li>
                <li> Ensure the security of corporate data and systems.</li>
                <li>Provide secure email and data transmission services.</li>
                <li>Comply with legal obligations and internal policies.</li>
                <li> Improve the functionality and features of our products.</li>            
            </ul>
            <h5 class="policy-title">3. Sharing of Information</h5>
            <p>We do not sell, rent, or share your personal data with third parties, except as follows:</p>
            <ul class="policy-list">
                <li>
                    <b>Service Providers:</b>
                    We may share data with trusted third-party service providers who assist us in delivering our services (e.g., cloud storage providers, analytics services).
                </li>
                <li>
                    <b>Legal Requirements:</b>
                    We may disclose your data if required by law, legal process, or governmental request.
                </li>
                <li>
                    <b>Business Transfers:</b>
                    In the event of a merger, acquisition, or sale of assets, your information may be transferred to a successor organization.
                </li>
            </ul>
            <h5 class="policy-title">4. Data Security</h5>
            <p>We implement industry-standard security measures, including encryption, access controls, and regular security audits, to safeguard your information from unauthorized access, alteration, or disclosure.</p>
            <h5 class="policy-title">5. Data Retention</h5>
            <p>We retain personal data for as long as necessary to fulfill the purposes for which it was collected, including legal, regulatory, and compliance obligations.</p>
            <h5 class="policy-title">6. Your Rights</h5>
            <p>Depending on your location and applicable laws, you may have certain rights concerning your personal data, including the right to:</p>
            <ul class="policy-list">
                <li> Access your data.</li>
                <li>Request correction of inaccurate data.</li>
                <li>Request deletion of your data.</li>
                <li>Object to the processing of your data.</li>
            </ul>
            <p>To exercise your rights, please contact us at contact@secureforme.io</p>
            <h5 class="policy-title"> 7. Changes to the Privacy Policy</h5>
            <p>
                We may update this Privacy Policy periodically to reflect changes in our practices or applicable laws. We encourage you to review this page regularly for the latest information on our privacy practices.
            </p>
            <h5 class="policy-title"> 8. Contact Information</h5>
            <p>If you have any questions or concerns regarding this Privacy Policy, please contact us at:</p>
            <ul class="policy-add-list">
                <li><b>Company Name:</b> Innovly Private Limited</li>
                <li><b>Address:</b> 177/3C, EM Corner, Iraniyan Street, Manickavasagar Colony, Erode, Tamil Nadu, 638002</li>
                <li><b>Email:</b> contact@secureforme.io</li>
                <li><b>Phone:</b> +91 8870007553</li>
            </ul>
        </div>
    </section>
        </>
  );
}

export default Privacy;